import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, Card, Typography, Space } from 'antd';
import { MailOutlined, DashboardOutlined, EditOutlined, TeamOutlined, SendOutlined, InboxOutlined, FileTextOutlined } from '@ant-design/icons';
import EMDashboard from './EMDashboard';
import EMCompose from './EMCompose';
import EMContacts from './EMContacts';
import EMCampaigns from './EMCampaigns';
import EMInbox from './EMInbox';
import EMTemplates from './EMTemplates';

const { Title, Text } = Typography;

export default function EmailMarketingPage() {
  const [activeTab, setActiveTab] = useState('dashboard');

  const items = [
    { key: 'dashboard', label: <span><DashboardOutlined /> Dashboard</span>, children: <EMDashboard /> },
    { key: 'compose', label: <span><EditOutlined /> AI Compose</span>, children: <EMCompose /> },
    { key: 'contacts', label: <span><TeamOutlined /> Contacts</span>, children: <EMContacts /> },
    { key: 'campaigns', label: <span><SendOutlined /> Campaigns</span>, children: <EMCampaigns /> },
    { key: 'inbox', label: <span><InboxOutlined /> Inbox</span>, children: <EMInbox /> },
    { key: 'templates', label: <span><FileTextOutlined /> Templates</span>, children: <EMTemplates /> },
  ];

  return (
    <div>
      <Card style={{ marginBottom: 24 }} styles={{ body: { padding: 0 } }}>
        <div style={{
          background: 'linear-gradient(135deg, #00b4d8 0%, #0077b6 100%)',
          padding: '32px 32px 28px',
          borderRadius: '8px 8px 0 0',
        }}>
          <Space align="center" size={16}>
            <MailOutlined style={{ fontSize: 32, color: '#fff' }} />
            <div>
              <Title level={3} style={{ margin: 0, color: '#fff' }}>EMBot - AI Email Marketing</Title>
              <Text style={{ color: 'rgba(255,255,255,0.85)' }}>AI-powered email marketing with comboware.tw</Text>
            </div>
          </Space>
        </div>
      </Card>

      <Tabs activeKey={activeTab} onChange={setActiveTab} items={items} size="large" />
    </div>
  );
}
